<template>
  <v-list-item v-if="!isEditing" ripple class="it-hv">
    <abt-item-avatar :icon="'fal fa-dog'" :note="''" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isStatusEmpty">滞在先の家の中にペットの了承</v-list-item-subtitle>
      <v-list-item-title>{{ printStatus }}</v-list-item-title>
      <v-list-item-subtitle v-if="printNote" class="caption">{{ printNote }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-radio-group required row
          v-model="form.status"
          :rules="rules.status"
          label="ペットが家にいてもいいですか？">
          <v-radio v-for="(item, idx) in getStatusItems" :key="`pets_status_${idx}`"
            color="blue darken-2"
            :label="item"
            :value="item"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="form.note"
          label="備考欄"
          counter="50"
          :rules="rules.note"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../../components/avatar'
export default {
  name: 'clientAboutBackgroundsHomestayPets',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'pets',
        datepicker: {
          publish: false,
          expire: false
        }
      },
      meta: {
        status: [ 'はい', 'いいえ' ]
      },
      form: {
        id: '',
        status: '',
        note: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: `${dt.id || ''}`,
          status: dt.status || '',
          note: dt.note || ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: `${this.$props.data.id || ''}`,
          status: this.$props.data.status || '',
          note: this.$props.data.note || ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: this.config.type
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === this.config.type)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === this.config.type
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === this.config.type
      )
    },
    getStatusItems () {
      return this.meta.status
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status
      ) ? this.$props.data.status : '滞在先家庭のペットについての回答'
    },
    isStatusEmpty () {
      return !(this.$props.data && this.$props.data.status)
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.note
      ) ? this.$props.data.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.note
      )
    }
  }
}
</script>
